import { motion } from 'motion/react';
import { Package, Layers, Warehouse, ShoppingCart, DollarSign, FileText } from 'lucide-react';

export const Overview = () => {
  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-10">
        {[
          { label: 'سفارشات جدید', value: '۱۲', icon: ShoppingCart, color: 'text-blue-600', bg: 'bg-blue-50 dark:bg-blue-900/20' },
          { label: 'کالاهای ثبت شده', value: '۱۴۵', icon: Package, color: 'text-emerald-600', bg: 'bg-emerald-50 dark:bg-emerald-900/20' },
          { label: 'فاکتورهای صادر شده', value: '۳۸', icon: FileText, color: 'text-purple-600', bg: 'bg-purple-50 dark:bg-purple-900/20' },
          { label: 'موجودی صندوق (ریال)', value: '۲۴,۵۰۰,۰۰۰', icon: DollarSign, color: 'text-amber-600', bg: 'bg-amber-50 dark:bg-amber-900/20' },
        ].map((stat, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.1 }}
            className="bg-white dark:bg-slate-800 p-6 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 flex items-center space-x-4 space-x-reverse"
          >
            <div className={`w-14 h-14 rounded-xl flex items-center justify-center ${stat.bg} ${stat.color} shrink-0`}>
              <stat.icon size={28} />
            </div>
            <div>
              <p className="text-sm font-medium text-slate-500 dark:text-slate-400 mb-1">{stat.label}</p>
              <p className="text-2xl font-extrabold text-slate-800 dark:text-white">{stat.value}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-6"
        >
           <h3 className="font-bold text-xl text-slate-800 dark:text-white mb-4">آخرین فعالیت‌ها</h3>
           <div className="text-slate-500 dark:text-slate-400 text-sm py-8 text-center">
             هنوز فعالیتی ثبت نشده است.
           </div>
        </motion.div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="bg-white dark:bg-slate-800 rounded-2xl shadow-sm border border-slate-100 dark:border-slate-700 p-6"
        >
           <h3 className="font-bold text-xl text-slate-800 dark:text-white mb-4">وضعیت انبارها</h3>
           <div className="text-slate-500 dark:text-slate-400 text-sm py-8 text-center">
             داده‌های انبار به زودی اضافه می‌شود.
           </div>
        </motion.div>
      </div>
    </div>
  );
};
